import { Box, useTheme } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

import { TextTag } from 'src/components/text-tag'
import { EPromptsGlobalImageVariables } from 'src/constants'
import { ESettingsImagesFields, IUpdateSettingsImagesPayloadDto } from 'src/types'

interface ISettingsVariablesItem {
  variable: EPromptsGlobalImageVariables
  imageUrl: string
  setImage: Dispatch<SetStateAction<IUpdateSettingsImagesPayloadDto | null>>
}

export const GlobalSettingsVariablesImageItem = ({
  variable,
  imageUrl,
  setImage,
}: ISettingsVariablesItem) => {
  const theme = useTheme()

  const getFieldName = (variable: EPromptsGlobalImageVariables): ESettingsImagesFields => {
    switch (variable) {
      case EPromptsGlobalImageVariables.IMAGE_1:
        return ESettingsImagesFields.IMAGE_1
      case EPromptsGlobalImageVariables.IMAGE_2:
        return ESettingsImagesFields.IMAGE_2
      case EPromptsGlobalImageVariables.IMAGE_3:
        return ESettingsImagesFields.IMAGE_3
      case EPromptsGlobalImageVariables.IMAGE_4:
        return ESettingsImagesFields.IMAGE_4
      case EPromptsGlobalImageVariables.IMAGE_5:
        return ESettingsImagesFields.IMAGE_5
      default:
        throw new Error('Unknown image variable')
    }
  }

  const handleClick = () => {
    const field = getFieldName(variable)
    setImage({ field, value: imageUrl })
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <TextTag
        label={variable}
        bgColor={theme.palette.custom.lightGreen}
        color={theme.palette.custom.darkBlue2}
        fontSize="14px"
        size="medium"
        sx={{ fontWeight: 500, fontStyle: 'italic' }}
      />
      <img
        src={imageUrl}
        alt={''}
        style={{ width: '100px', height: '100px', borderRadius: '4px' }}
      />
    </Box>
  )
}
